import { render, staticRenderFns } from "./WsTabCarousel001.vue?vue&type=template&id=d424998a&scoped=true"
import script from "./WsTabCarousel001.vue?vue&type=script&lang=js"
export * from "./WsTabCarousel001.vue?vue&type=script&lang=js"
import style0 from "./WsTabCarousel001.vue?vue&type=style&index=0&id=d424998a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d424998a",
  null
  
)

export default component.exports